<template>
  <div class="pb-6">
    <field-label :field="field"></field-label>

    <v-btn-toggle
      group
      class="d-block"
      :value="value"
      mandatory
      @change="input"
    >
      <v-btn
        v-for="option in colors"
        :key="option.value"
        small
        :value="option.value"
      >
        <div
          v-if="option.value != 'inherit'"
          class="elevation-2 mr-2"
          :style="{
            backgroundColor: option.value,
            width: '20px',
            height: '10px'
          }"
        ></div>
        {{ option.text }}
      </v-btn>
    </v-btn-toggle>
  </div>
</template>

<script>
import FieldLabel from '@/components/editor/partials/FieldLabel'

export default {
  name: 'TextColorField',
  props: ['value', 'field'],
  components: {
    FieldLabel
  },
  data: () => ({
    colors: [
      { value: 'inherit', text: 'Default' },
      { value: 'var(--text-dark-color)', text: 'Dark' },
      { value: 'var(--text-light-color)', text: 'Light' },
      { value: 'var(--primary-color)', text: 'Primary' },
      { value: 'var(--secondary-color)', text: 'Secondary' },
      { value: 'var(--accent-color)', text: 'Accent' }
    ]
  }),
  computed: {
    rules() {
      let rules = this.field.rules || []

      return rules.map(rule => this.$store.state.editor.validation.rules[rule])
    }
  },
  methods: {
    input(value) {
      this.$emit('update:value', value)
    },
    setDefaultValue() {
      // TODO - fix default value set up
      // if (this.value === undefined && this.field.default !== undefined) {
      //   this.input(this.field.default)
      // }
    }
  },
  mounted() {
    this.setDefaultValue()
  }
}
</script>
